module.exports = __webpack_public_path__ + "img/4.38d3bed4.png";